import axiosInstance from "../utils/axios";

export async function GetCareerList(values, cancelToken) {
  return await axiosInstance().post(`/getCareerList`, values, {
    cancelToken: cancelToken
  });
}

export async function GetCareerListFilters(cancelToken) {
  return await axiosInstance().get(`/getCareerListFilters`, {
    cancelToken: cancelToken
  });
}

export async function GetCareer(id, cancelToken) {
  return await axiosInstance().get(`/getCareerLibraryCareer?id=${id}`, {
    cancelToken: cancelToken
  });
}

export async function UpdateCareer(values) {
  return await axiosInstance().post(`/updateCareer`, values);
}

export async function DeleteCareer(id) {
  return await axiosInstance().post(`/deleteCareer`, { id: id });
}

export async function CreateCareerTag(values) {
  return await axiosInstance().post(`/createCareerTag`, values);
}

export async function DeleteCareerTag(id) {
  return await axiosInstance().post(`/deleteCareerTag`, { id: id });
}

export async function AuditTrailCareer(values, cancelToken) {
  return await axiosInstance().post(`/auditTrailCareer`, values, {
    cancelToken: cancelToken
  });
}

export async function AuditTrailFilterCareer(values, cancelToken) {
  return await axiosInstance().get(`/auditTrailFilterCareer`, {
    params: values,
    cancelToken: cancelToken
  });
}

export async function GetProgrammeCareerLinks(pmcId, pmcType, cancelToken) {
  return await axiosInstance().get(
    `/getProgrammeCareerLinks?pmc_id=${pmcId}&pmc_type=${pmcType}`,
    { cancelToken: cancelToken }
  );
}

export async function UpdateProgrammeCareerLinks(values) {
  return await axiosInstance().post(`/updateProgrammeCareerLinks`, values);
}

export async function GetLinkableProgrammes(cancelToken) {
  return await axiosInstance().get(`/getLinkableProgrammes`, {
    cancelToken: cancelToken
  });
}
